import { ButtonGroup } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { NestingIconData } from "../../../../Data/ButtonsData/GroupButtonData";
import { Fragment } from "react/jsx-runtime";

export const NestingButtonIcons = () => {
  return (
    <Fragment>
      {NestingIconData.map((list) => (
        <div className="m-b-30" key={list.id}>
          <ButtonGroup>
            {list.child.map((item) => (
              <Btn color={item.color} size={item.size ? item.size : ""} key={item.id}>
                <i className={`fa ${item.iconClass}`}></i>
              </Btn>
            ))}
          </ButtonGroup>
        </div>
      ))}
    </Fragment>
  );
};
